package features.watch.model

import kotlinx.serialization.Serializable

@Serializable
data class WatchEntry(
    val videoId: String,
    val imdbId: String? = null,
    val isTvShow: Boolean = false,
    val seasonNumber: Int = 0,
    val episodeNumber: Int = 0,
    val positionSec: Int = 0,
    val durationSec: Int = 0,
    val progress: Double = 0.0,
    val engagedSec: Int = 0,
    val status: String = STATUS_IN_PROGRESS,
    val title: String? = null,
    val imageUrl: String? = null,
    val backdropUrl: String? = null,
    val audio: String? = null,
    val quality: String? = null,
    val subtitles: String? = null,
    val hiddenFromContinue: Boolean = false,
    val isDeleted: Boolean = false,
    val changedAt: String = "",
) {
    val videoIdInt: Int get() = videoId.toIntOrNull() ?: -1

    fun embedUrl(): String? {
        val id = imdbId?.takeIf { it.isNotBlank() } ?: return null
        return if (isTvShow && (seasonNumber > 0 || episodeNumber > 0)) {
            "https://api.tobaco.ws/embed/imdb/$id?season=$seasonNumber&episode=$episodeNumber&host=filmot.site&episodesOpen=false"
        } else {
            "https://api.tobaco.ws/embed/imdb/$id?host=filmot.site"
        }
    }

    companion object {
        const val STATUS_IN_PROGRESS = "IN_PROGRESS"
        const val STATUS_COMPLETED = "COMPLETED"
    }
}

data class PlaybackChoice(
    val audio: String? = null,
    val quality: String? = null,
    val subtitles: String? = null,
)

data class WatchTarget(
    val seasonNumber: Int,
    val episodeNumber: Int,
    val positionSec: Int,
    val completed: Boolean,
    val queuedNext: Boolean,
)

@Serializable
data class WatchSyncBody(
    val items: List<WatchEntry> = emptyList(),
    val language: String = "",
)
